import React from "react";
export const Folder = () => (
  <svg fill="none" viewBox="0 0 14 13">
    <path
      d="M.82 11.27l.89.37V5.62L.1 9.53c-.28.68.05 1.46.72 1.74zm13-2.47L10.51.82c-.2-.5-.69-.81-1.2-.82-.17 0-.35.03-.53.1L3.87 2.13c-.5.21-.81.69-.82 1.2-.01.18.03.36.1.53l3.31 7.98c.21.51.7.81 1.22.82.17 0 .35-.03.51-.1l4.91-2.03c.68-.28 1-1.06.72-1.73zM4.39 4a.67.67 0 110-1.34.67.67 0 010 1.34zm-1.33 7.33c0 .73.6 1.33 1.33 1.33h.97L3.06 7.1v4.23z"
      fill="#192547"
    />
  </svg>
);
